import React, { Component } from 'react';
import { css } from 'aphrodite';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import 'rc-slider/assets/index.css';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';

export class MultiCamPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCamIds: this.props.selectedCamIds
    }
  }

  onChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    }, () => { this.props.camSelectHandler(this.state.selectedCamIds) });
  }

  render() {
    if (!this.props.place || !this.props.place.cams) {
      return
    }

    return (
      <FormControl className={css(Styles.multiPickerForm)}>
        <Select
          name='selectedCamIds'
          multiple
          value={this.state.selectedCamIds}
          renderValue={selected => (
            this.props.place.cams.map(cam => {
              return (
                selected.map((eventSelected, index ) => {
                  if(selected.length - 1 === index) {
                    return (
                      eventSelected === cam._id &&
                      [cam.name]
                    )
                  } else {
                    return (
                      eventSelected === cam._id &&
                      [cam.name] + ', '
                    )
                  }

                }))
            })
          )}
          className={css(Styles.pickerInnerContainer)}
          onChange={this.onChange}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null,
            classes: {
              paper: css(CommonStyles.menuItemContainerRoot),
              list: css(CommonStyles.menuItemListContainerRoot)
            }
          }}
          input={
            <Input
              disableUnderline={true}
            />
          }
          classes={{
            selectMenu: css(Styles.selectOrgMenu),
            icon: css(Styles.selectIcon),
          }}
        >
          {this.props.place.cams.map(item => {
            return (
              <MenuItem
                value={item._id}
                key={item._id}
                className={css(CommonStyles.menuItemContainer)}>
                <Checkbox checked={this.state.selectedCamIds.indexOf(item._id) > -1}
                  className={css(Styles.selectCheckbox)} />
                <p className={css(CommonStyles.margin)}>{item.name}</p>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/ClientPlace/MultiCamPicker.js